import React from 'react'
import { subscribe } from 'react-contextual'
import { PaymentsProvider } from '../../../providers'
import { SearchFilter } from '../..'
import { $TSFixMe } from 'types/ts-migrate'

interface PaymentsSearchFilterProps {
  pathname: string
  redirect: (path: string) => void
  filters: $TSFixMe
}

const PaymentsSearchFilter = (props: PaymentsSearchFilterProps): React.ReactElement => <SearchFilter {...props} />

export default subscribe([PaymentsProvider], ({ location, redirect, paymentFilters }: any) => ({
  pathname: location.pathname,
  redirect,
  filters: paymentFilters,
}))(PaymentsSearchFilter)
